var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomePageVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49987 14.2106C4.60941 14.2106 4.75496 14.1443 4.82567 14.0771L8.85219 10.2876C9.03508 10.1107 9.05623 9.82405 8.8707 9.61786C8.70466 9.43349 8.38101 9.42886 8.20076 9.59936L4.97368 12.6412L4.97368 0.473652C4.97368 0.211957 4.76155 0 4.50002 0C4.23833 0 4.02637 0.21213 4.02637 0.473652L4.02637 12.6412L0.799292 9.59936C0.619046 9.42886 0.303308 9.44092 0.129522 9.61786C-0.0540257 9.80455 -0.0376701 10.1135 0.148026 10.2876L4.17438 14.0771C4.28358 14.1885 4.38882 14.2088 4.50001 14.2106H4.49987Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomePageVector);
export default __webpack_public_path__ + "static/media/HomePageVector.022d5bbe2de0b245451c8b4c594695d7.svg";
export { ForwardRef as ReactComponent };